export interface StoryPhoto {
  url: string | null;
  alt: string;
  featured?: boolean;
}

export interface StoryCase {
  id: string;
  number: number;
  monthLabel: string;
  destination: string;
  tags: string[];
  quote: string;
  summary: string;
  longFeedback?: boolean;
  chatImage: string | null;
  chatAlt: string;
  photos: StoryPhoto[];
  featured: boolean;
}

// 已上传图片URL映射（其余24张待补充）
export const uploadedImageUrls: Record<string, string> = {
  'fw-story-13-tanzania-2026-07-photo-river-landscape':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/e17926d1-0fa7-4e5f-afbe-36d79428199a_compressed_fw-story-13-tanzania-2026-07-photo-river-landscape.webp',
  'fw-story-11-rwanda-botswana-2026-06-chat':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/f70cef56-bf04-4683-a356-e633714d899f_compressed_fw-story-11-rwanda-botswana-2026-06-chat.webp',
  'fw-story-06-tanzania-2026-02-chat':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/cbbae91b-3a92-49fd-8388-22b3d6c40060_compressed_fw-story-06-tanzania-2026-02-chat.webp',
  'fw-story-13-tanzania-2026-07-photo-elephant-camera':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/b3e5ec44-6bd3-4f5f-a02d-0e8244038015_compressed_fw-story-13-tanzania-2026-07-photo-elephant-camera.webp',
  'fw-story-13-tanzania-2026-07-chat':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/dd831dff-e6df-4890-9bdf-649de2f1bbc9_compressed_fw-story-13-tanzania-2026-07-chat.webp',
  'fw-story-07-tanzania-2026-02-chat':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/2ec477fa-e5b4-4078-833a-609412a143d1_compressed_fw-story-07-tanzania-2026-02-chat.webp',
  'fw-story-13-tanzania-2026-07-photo-lioness-cubs':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/925374e2-7e7e-4800-aa2b-f1c2b8bad9e0_compressed_fw-story-13-tanzania-2026-07-photo-lioness-cubs.webp',
  'fw-story-08-tanzania-2026-02-chat':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/6d93d6ec-557b-432d-a863-12c39b6090a2_compressed_fw-story-08-tanzania-2026-02-chat.webp',
  'fw-story-09-tanzania-2026-05-chat':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/f33f2c89-fe22-4aad-a469-b3d13002bcbf_compressed_fw-story-09-tanzania-2026-05-chat.webp',
  'fw-story-12-tanzania-2026-06-chat':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/7a1132f0-5d09-4b94-bec4-66239c524791_compressed_fw-story-12-tanzania-2026-06-chat.webp',
  'fw-story-04-tanzania-2026-04-photo-leopard-tree':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/ae22edf5-e57c-4c60-8358-dd1ca0235ba9_compressed_fw-story-04-tanzania-2026-04-photo-leopard-tree.webp',
  'fw-story-04-tanzania-2026-04-photo-cheetah':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/dbf7a38f-31a3-4789-8dbe-b07c7d6892d8_compressed_fw-story-04-tanzania-2026-04-photo-cheetah.webp',
  'fw-story-04-tanzania-2026-04-photo-zebras':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/65b22b80-2f02-49d8-a23c-9e75fc9284a9_compressed_fw-story-04-tanzania-2026-04-photo-zebras.webp',
  'fw-story-05-tanzania-2026-05-photo-cheetahs-roof-wide':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/1292db87-0405-40a4-a64c-0539f3416650_compressed_fw-story-05-tanzania-2026-05-photo-cheetahs-roof-wide.webp',
  'fw-story-01-tanzania-2026-02-chat':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/2773167a-282c-434f-9492-aed8b88cdb6c_compressed_fw-story-01-tanzania-2026-02-chat.webp',
  'fw-story-01-tanzania-2026-02-photo-leopard':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/4dbdb4a3-e1cd-4578-9b34-f8c93645b9e7_compressed_fw-story-01-tanzania-2026-02-photo-leopard.webp',
  'fw-story-01-tanzania-2026-02-photo-cheetah-cubs':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/3348eb68-6c70-483d-85e5-3a9ed80b35dc_compressed_fw-story-01-tanzania-2026-02-photo-cheetah-cubs.webp',
  'fw-story-01-tanzania-2026-02-photo-giraffe':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/4f8f9250-986d-4769-b7b1-88b6a2e5d396_compressed_fw-story-01-tanzania-2026-02-photo-giraffe.webp',
  'fw-story-02-tanzania-2026-02-photo-lioness':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/6bec396d-eff6-47f6-8f67-8c8e11246e57_compressed_fw-story-02-tanzania-2026-02-photo-lioness.webp',
  'fw-story-02-tanzania-2026-02-photo-serval':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/5b03a1f4-cf1f-4295-9080-41668da0aff2_compressed_fw-story-02-tanzania-2026-02-photo-serval.webp',
  'fw-story-03-botswana-2026-03-chat':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/32e39032-2751-4056-ac5d-8a9779814037_compressed_fw-story-03-botswana-2026-03-chat.webp',
  'fw-story-03-botswana-2026-03-photo-leopard':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/f3815d81-871a-4b13-b902-998c890bc115_compressed_fw-story-03-botswana-2026-03-photo-leopard.webp',
  'fw-story-03-botswana-2026-03-photo-elephants-water':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/0d507552-ea9a-4d84-a279-76fdcff33400_compressed_fw-story-03-botswana-2026-03-photo-elephants-water.webp',
  'fw-story-02-tanzania-2026-02-chat':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/15aafc38-7321-4836-94c8-4cbcf0749c46_compressed_fw-story-02-tanzania-2026-02-chat.webp',
  'fw-story-02-tanzania-2026-02-photo-elephants':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/40ab81a3-fca2-4c57-8b1a-93abea66a5c4_compressed_fw-story-02-tanzania-2026-02-photo-elephants.webp',
  'fw-story-03-botswana-2026-03-photo-lion-cub':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/ec43a812-81df-4bae-b820-b91f87c1bc21_compressed_fw-story-03-botswana-2026-03-photo-lion-cub.webp',
  'fw-story-04-tanzania-2026-04-chat':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/dbbbb074-2560-48d7-88cc-6320ed605ff1_compressed_fw-story-04-tanzania-2026-04-chat.webp',
  'fw-story-05-tanzania-2026-05-chat':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/aad7a717-02f3-4a19-8de0-ab7b64516455_compressed_fw-story-05-tanzania-2026-05-chat.webp',
  'fw-story-05-tanzania-2026-05-photo-cheetah-roof-close':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/3200091d-58c2-45a7-a207-9e5417961e54_compressed_fw-story-05-tanzania-2026-05-photo-cheetah-roof-close.webp',
  'fw-story-05-tanzania-2026-05-photo-cheetahs-roof-angle':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/524a419c-f7b1-4afc-941a-9e4ab8916205_compressed_fw-story-05-tanzania-2026-05-photo-cheetahs-roof-angle.webp',
  'fw-story-10-tanzania-2026-05-chat':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/e3d52268-f010-496a-9141-a72ea79b46ce_compressed_fw-story-10-tanzania-2026-05-chat.webp',
  'fw-story-14-tanzania-2026-08-chat':
    'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/d2fa2597-9e3a-4c11-827b-357a5665f89a_compressed_fw-story-14-tanzania-2026-08-chat.webp',
};

export function getImageUrl(filename: string): string | null {
  return uploadedImageUrls[filename] ?? null;
}

export const cases: StoryCase[] = [
  {
    id: '01',
    number: 1,
    monthLabel: '2026年2月',
    destination: '坦桑尼亚',
    tags: ['酒店与向导'],
    quote: '这几天玩儿得太好了！酒店选得好，向导也好。',
    summary: '客户在旅途中肯定整体体验、酒店选择和当地向导，并在信号恢复后继续分享动物观察照片。',
    chatImage: getImageUrl('fw-story-01-tanzania-2026-02-chat'),
    chatAlt: '匿名客户反馈截图，客户肯定坦桑尼亚酒店和向导',
    photos: [
      { url: getImageUrl('fw-story-01-tanzania-2026-02-photo-leopard'), alt: '客户拍摄的非洲豹', featured: true },
      { url: getImageUrl('fw-story-01-tanzania-2026-02-photo-cheetah-cubs'), alt: '客户拍摄的猎豹幼崽' },
      { url: getImageUrl('fw-story-01-tanzania-2026-02-photo-giraffe'), alt: '客户拍摄的长颈鹿' },
    ],
    featured: true,
  },
  {
    id: '02',
    number: 2,
    monthLabel: '2026年2月',
    destination: '坦桑尼亚',
    tags: ['主动推荐'],
    quote: '我朋友看到我来非洲玩很羡慕，她也想来非洲玩，我会给她推荐你们公司的。',
    summary: '客户主动表达向朋友推荐自由旷野，并分享象群、狮子和薮猫等动物观察照片。',
    chatImage: getImageUrl('fw-story-02-tanzania-2026-02-chat'),
    chatAlt: '匿名客户反馈截图，客户表示会向朋友推荐自由旷野',
    photos: [
      { url: getImageUrl('fw-story-02-tanzania-2026-02-photo-elephants'), alt: '客户拍摄的象群', featured: true },
      { url: getImageUrl('fw-story-02-tanzania-2026-02-photo-lioness'), alt: '客户拍摄的母狮' },
      { url: getImageUrl('fw-story-02-tanzania-2026-02-photo-serval'), alt: '客户拍摄的薮猫' },
    ],
    featured: true,
  },
  {
    id: '03',
    number: 3,
    monthLabel: '2026年3月',
    destination: '博茨瓦纳',
    tags: ['响应与再次选择'],
    quote: '非常感谢各位，随时响应，耐心帮我解决一切问题！这是一次非常难忘的旅行。',
    summary: '客户肯定响应速度与问题处理，并明确表达未来再次选择的意愿。',
    chatImage: getImageUrl('fw-story-03-botswana-2026-03-chat'),
    chatAlt: '匿名客户反馈截图，客户肯定响应速度并表达再次选择意愿',
    photos: [
      { url: getImageUrl('fw-story-03-botswana-2026-03-photo-lion-cub'), alt: '客户拍摄的狮子幼崽', featured: true },
      { url: getImageUrl('fw-story-03-botswana-2026-03-photo-leopard'), alt: '客户拍摄的非洲豹' },
      { url: getImageUrl('fw-story-03-botswana-2026-03-photo-elephants-water'), alt: '客户拍摄的水边象群' },
    ],
    featured: true,
  },
  {
    id: '04',
    number: 4,
    monthLabel: '2026年4月',
    destination: '坦桑尼亚',
    tags: ['专业向导'],
    quote: '这次旅途向导非常靠谱、特别专业，整个旅行安排很合理；酒店和餐食也都非常不错。',
    summary: '客户肯定向导专业度、国家公园停留时间、行程安排及酒店餐食，并表达未来再次预订动物迁徙季行程的想法。',
    chatImage: getImageUrl('fw-story-04-tanzania-2026-04-chat'),
    chatAlt: '匿名客户反馈截图，客户肯定向导专业度和行程安排',
    photos: [
      { url: getImageUrl('fw-story-04-tanzania-2026-04-photo-leopard-tree'), alt: '客户拍摄的树上的非洲豹', featured: true },
      { url: getImageUrl('fw-story-04-tanzania-2026-04-photo-cheetah'), alt: '客户拍摄的猎豹' },
      { url: getImageUrl('fw-story-04-tanzania-2026-04-photo-zebras'), alt: '客户拍摄的斑马群' },
    ],
    featured: true,
  },
  {
    id: '05',
    number: 5,
    monthLabel: '2026年5月',
    destination: '坦桑尼亚',
    tags: ['旅途现场'],
    quote: '这个小猎豹差点掉进来，吓死我了！大家都好羡慕。',
    summary: '客户在行程群即时分享猎豹登上观景车车顶的观察经历；此节点用于呈现真实旅途现场，不作为服务评分。',
    chatImage: getImageUrl('fw-story-05-tanzania-2026-05-chat'),
    chatAlt: '匿名客户行程群分享，客户即时分享猎豹登上观景车顶的观察经历',
    photos: [
      { url: getImageUrl('fw-story-05-tanzania-2026-05-photo-cheetahs-roof-wide'), alt: '客户拍摄的猎豹登上观景车车顶', featured: true },
      { url: getImageUrl('fw-story-05-tanzania-2026-05-photo-cheetah-roof-close'), alt: '客户拍摄的猎豹特写' },
      { url: getImageUrl('fw-story-05-tanzania-2026-05-photo-cheetahs-roof-angle'), alt: '客户拍摄的猎豹侧面' },
    ],
    featured: true,
  },
  {
    id: '06',
    number: 6,
    monthLabel: '2026年2月',
    destination: '坦桑尼亚',
    tags: ['家庭同行'],
    quote: '行程不错了，小朋友、大朋友都很开心。司机和导游都很好，啊不错的。',
    summary: '该反馈明确提到儿童与成人同行，并肯定司机和向导，适合作为家庭旅行需求的真实切面。',
    chatImage: getImageUrl('fw-story-06-tanzania-2026-02-chat'),
    chatAlt: '匿名客户反馈截图，客户表示小朋友和大朋友都很开心，并肯定司机与导游',
    photos: [],
    featured: false,
  },
  {
    id: '07',
    number: 7,
    monthLabel: '2026年2月',
    destination: '坦桑尼亚',
    tags: ['国内协调与安心'],
    quote: '本次非洲之行交给了自由旷野定制，向导Morris很优秀，各种细节都很用心。出国旅游有一个国内旅行社对接比较安心。以后我的南极之行也要靠自由旷野了。',
    summary: '客户肯定定制细节、当地向导和国内协调带来的安心感，并表达未来再次咨询其他目的地的意向。',
    chatImage: getImageUrl('fw-story-07-tanzania-2026-02-chat'),
    chatAlt: '匿名客户反馈节选，客户肯定非洲定制细节、向导表现和国内协调服务',
    photos: [],
    featured: false,
  },
  {
    id: '08',
    number: 8,
    monthLabel: '2026年2月',
    destination: '坦桑尼亚',
    tags: ['再次选择意向'],
    quote: '好，你很认真负责，非常点赞，体验挺好的。下次找机会，也许是南极，或者别的目的地，你有合适的可以推我。',
    summary: '客户肯定服务的认真负责，并主动询问未来南极或其他目的地的合适行程。',
    chatImage: getImageUrl('fw-story-08-tanzania-2026-02-chat'),
    chatAlt: '匿名客户反馈截图，客户肯定服务认真负责并表达下一次旅行咨询意向',
    photos: [],
    featured: false,
  },
  {
    id: '09',
    number: 9,
    monthLabel: '2026年5月',
    destination: '坦桑尼亚',
    tags: ['高端营地'],
    quote: '本来以为到非洲是来吃苦的，没想到这么享受，吃的住的都非常好……所有工作人员都服务超好，这次行程体验感是所有去过的地方最好的一次。',
    summary: '客户从住宿餐食、向导与司机、野生动物观察、用餐仪式感和行李服务多个方面记录了营地体验。',
    longFeedback: true,
    chatImage: getImageUrl('fw-story-09-tanzania-2026-05-chat'),
    chatAlt: '匿名客户长反馈节选，客户评价坦桑尼亚营地住宿餐食、向导和旅途服务',
    photos: [],
    featured: false,
  },
  {
    id: '10',
    number: 10,
    monthLabel: '2026年5月',
    destination: '坦桑尼亚',
    tags: ['朋友口碑'],
    quote: '棒得很。我们十几个朋友要了。因为你太棒了哈哈哈。',
    summary: '客户表示已有多位朋友向其索取相关旅行信息，并把原因归于本次体验。',
    chatImage: getImageUrl('fw-story-10-tanzania-2026-05-chat'),
    chatAlt: '匿名客户聊天节选，客户表示多位朋友索取旅行信息并肯定本次服务',
    photos: [],
    featured: false,
  },
  {
    id: '11',
    number: 11,
    monthLabel: '2026年6月',
    destination: '卢旺达、博茨瓦纳等多国行程',
    tags: ['多国深度行程'],
    quote: '在伦敦转机，还剩最后一程。小结一下此行程的感受和观察，也是给你们反馈吧。1.一切顺利，再次感谢。机场接机特别有帮助……',
    summary: '客户以分点长反馈复盘跨国行程，提到机场接送、签证衔接、大猩猩许可、营地入住及水上活动等环节。',
    longFeedback: true,
    chatImage: getImageUrl('fw-story-11-rwanda-botswana-2026-06-chat'),
    chatAlt: '匿名客户多国行程长反馈，记录机场接送、签证衔接、营地和活动体验',
    photos: [],
    featured: false,
  },
  {
    id: '12',
    number: 12,
    monthLabel: '2026年6月',
    destination: '坦桑尼亚',
    tags: ['野生动物摄影'],
    quote: '找的这家旅行社，推荐向导Huruma人超好、很有耐心，也很有经验，了解动物生活细节。拍照设备是vivo加增倍镜和iPhone。',
    summary: '客户从野生动物观察和拍摄角度肯定向导的耐心、经验及对动物生活细节的了解。',
    chatImage: getImageUrl('fw-story-12-tanzania-2026-06-chat'),
    chatAlt: '匿名客户公开反馈节选，客户肯定坦桑尼亚向导的耐心和野生动物知识',
    photos: [],
    featured: false,
  },
  {
    id: '13',
    number: 13,
    monthLabel: '2026年7月',
    destination: '坦桑尼亚',
    tags: ['现场观兽'],
    quote: '非洲五霸一天全看完了。到的当天晚上非洲豹就从我们车面前过去了，而且是个baby版，非常可爱。',
    summary: '客户连续分享首日及后续的动物观察经历；页面须同时说明野生动物观察不可复制、不可保证。',
    chatImage: getImageUrl('fw-story-13-tanzania-2026-07-chat'),
    chatAlt: '匿名客户反馈截图，客户分享坦桑尼亚非洲五霸观察经历',
    photos: [
      { url: getImageUrl('fw-story-13-tanzania-2026-07-photo-elephant-camera'), alt: '客户相机屏幕中记录的非洲草原象', featured: true },
      { url: getImageUrl('fw-story-13-tanzania-2026-07-photo-lioness-cubs'), alt: '客户拍摄的母狮与幼狮' },
      { url: getImageUrl('fw-story-13-tanzania-2026-07-photo-river-landscape'), alt: '客户拍摄的坦桑尼亚河流与草原环境' },
    ],
    featured: true,
  },
  {
    id: '14',
    number: 14,
    monthLabel: '2026年8月',
    destination: '坦桑尼亚',
    tags: ['全家回忆'],
    quote: '从一年前网上认识Sicily，到一年后旅途中的步步惊喜，这个团队实在让人太放心……这段满是惊喜的旅程会成为我们全家珍贵的回忆。期待下次再与非洲相见。',
    summary: '客户以长反馈回顾酒店、餐食、移动营地与行程协调，并将旅程描述为全家的珍贵回忆。',
    longFeedback: true,
    chatImage: getImageUrl('fw-story-14-tanzania-2026-08-chat'),
    chatAlt: '匿名家庭客户长反馈节选，回顾坦桑尼亚酒店、餐食、移动营地和全家旅程',
    photos: [],
    featured: false,
  },
];

export interface TravelTag {
  label: string;
  caseIds: string[];
  description: string;
}

export const travelTags: TravelTag[] = [
  { label: '家庭同行', caseIds: ['06', '14'], description: '儿童与成人同行的真实体验' },
  { label: '国内协调与安心', caseIds: ['07'], description: '国内旅行社对接带来的安心感' },
  { label: '专业向导', caseIds: ['04', '12'], description: '向导专业度与野生动物知识' },
  { label: '高端营地', caseIds: ['09'], description: '住宿、餐食与营地服务体验' },
  { label: '多国深度行程', caseIds: ['11'], description: '跨国行程衔接与复盘' },
  { label: '朋友口碑', caseIds: ['02', '10'], description: '客户主动向朋友推荐' },
  { label: '再次选择意向', caseIds: ['03', '08'], description: '客户表达未来再次选择意愿' },
  { label: '野生动物摄影与观兽', caseIds: ['05', '12', '13'], description: '野生动物观察与拍摄体验' },
];

export const timelineMonths = [
  {
    month: '2026年2月',
    caseIds: ['01', '02', '06', '07', '08'],
  },
  {
    month: '2026年3月',
    caseIds: ['03'],
  },
  {
    month: '2026年4月',
    caseIds: ['04'],
  },
  {
    month: '2026年5月',
    caseIds: ['05', '09', '10'],
  },
  {
    month: '2026年6月',
    caseIds: ['11', '12'],
  },
  {
    month: '2026年7月',
    caseIds: ['13'],
  },
  {
    month: '2026年8月',
    caseIds: ['14'],
  },
];

export const featuredCaseIds = ['01', '02', '03', '04', '05', '13'];

export const homePreviewCaseIds = ['03', '06', '11'];